module.exports = __webpack_public_path__ + "img/servicetext.7790dbeb.png";